import Header from './../../../Headers/HeaderForAreLoggedIn/index.vue'
import Footer from './../../../Footers/Footer/index.vue'
import ProgressHUD from './../../../ProgressHUD/index.vue'
import QuestionsAnswers from './../../Widget/QuestionsAnswers/index.vue'
import ReputationData from './../../Widget/ReputationData/index.vue'
import { Api, Toast } from './../../../../services'
import { ProductUpdateMixin } from './../../../mixins/ProductUpdate.mixin.js'
import { VueEditor } from 'vue2-editor'
let vm = require('vue')

export default {
  name: 'ProductEdit',
  mixins:[ProductUpdateMixin],
  components: {
    Header,
    Footer,
    ProgressHUD,
    QuestionsAnswers,
    ReputationData,
    VueEditor,
  },
  mounted() {},
  data() {
    return {
      product: {
        _id: '',
        name: '',
        description: '',
        specs: '',
        price: '',
        type: '',
        details: {
          number: '',
          weight: '',
          shipping: '',
          manufacture: '',
          asin: '',
        },
        images: [''],
        available: 0,
        accept: true,
        draft: false,
        country: "", 
        payMethods: '',
        region: "",
      },
      validationMessage: '',
      percents: [{"value": 10},{"value": 15}, {"value": 20}],
      payMethods: [{"name": "payment BTC", "value": "btc" }, {"name": "payment ETH", "value": "eth"}, {"name": "Credit Card", "value":"cc"}, {"name": "PayPal", "value": "pp"}],
      reviews: [],
      comment: [],
      draft: false,
      countries: [],
    }
  },
  methods: {
    saveDraftProduct() {      
      this.draft = true;
      this.saveProduct();
    }, 

    async saveProduct() {
      try {

      if (!this.draft) {           
        let isValid = await this.$validator.validateAll('firstForm')
        if (!isValid) {
            Toast.validationFieldsError({ toast: this.$toast })
            return 
        }    
      }  
      else {
        if (this.product.name == "") {
          Toast.validationFieldsError({ toast: this.$toast })
        }
      }   

      this.product.draft = this.draft 

      this.$refs.progress.show()
       
      var formData = new FormData()
      for (var key in this.product) {
          if (String(key) == 'details' || String(key) == 'images') break

          formData.append(key, this.product[key])
      }
     
      // Append images to formData
      if(!this.draft)
        for (
          var index = 0;
          !(!(index < this.product.images.length) || !(index < 5)); // Upload 5 images or less
          index++
        ) {
          formData.append('files' + index, this.product.images[index])
        }

      if (this.product.details) formData.append('details', String(JSON.stringify(this.product.details)))
      formData.append('specs', this.product.specs)
      formData.append('name', this.product.name)
      formData.append('description', this.product.description)
      formData.append('available', this.product.available)
      formData.append('price', this.product.price)
      formData.append('images', this.product.images)
      formData.append('country', this.product.country)
      formData.append('payMethods', this.product.payMethods)
      formData.append('draft', this.product.draft)

      var response = await Api.editProduct(formData)
      if (response.data) {
        console.log(response)
        this.$router.push('/product/private/' + this.product._id)
      } else {
        console.log(response.error)
        this.validationMessage = 'Something went wrong.'
        
      }

      } catch (error) {
        console.error(error)
        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {
        console.log("tutu>>>>>>>>>>>>>>>>>>>>>>")
        this.$refs.progress.hide()
      }
    },
  },
  async created() {
    this.countries = require('./../../../../data/country.js')

    var response = await Api.getProductById(this.$route.params.id)

    if (response.data && !response.data.error) {
      this.product = response.data.results.product
      this.reviews = response.data.results.opinion
      this.comment = response.data.results.comment
      this.newImages = [].concat(this.product.images)
    } else {
      this.validationMessage = 'Something went wrong.'
      console.error('Something went wrong.')
    }

    this.$nextTick(function() {
      $('select').material_select()
      Materialize.updateTextFields()
    })

    this.$refs.progress.hide()
  },
  mounted() {
    var _s = this
    this.$refs.selectCountry.onchange = function(){ 
      _s.product.country = this.value;
    }
    this.$refs.selectPayment.onchange = function(el){ 
      var selectedPay = [];
      for (let i = 0; i < 5; i++) 
        if (this[i].selected === true && !i==0) 
          selectedPay.push(this[i].value);        
          
      _s.product.payMethods = selectedPay;      
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/Product/Edit/ProductEdit.component.js